import { RootState } from "domain/store";

export const selectFolders = (state: RootState) => {
  return state.folders.folders;
};

export const selectIsFoldersLoading = (state: RootState) => {
  return state.folders.isFoldersLoading;
};

export const selectFolderSeances = (state: RootState) => {
  return state.folders.folderSeances;
};
